<template>
  <div :class="b()">
    <div :class="b('radio-warp')">
      <el-radio 
        v-for="item in list"
        :key="item.key"
        v-model="parentRadio" 
        :label="item.key"
        :class="b('radio-item')"
      >
        {{ item.name }}
      </el-radio>
    </div>

    <div 
      v-if="showChild"
      :class="[b('develop-plane'), b('radio-warp')]"
    >
      <el-radio 
        v-for="item in paramOptions"
        :key="item.field"
        v-model="childRadio" 
        :label="item.field"
        :class="[b('radio', 'child'), b('radio-item')]"
      >
        {{ item.fieldName }}
      </el-radio>
    </div>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
const CAN_QUERY_CODE = ['status', 'relationship', 'issueTypeId'];

export default {
  name: 'FormulaCustomPopoverItem',
  props: {
    params: {
      type: [Object, Array],
      default: null
    },
    requestFunc: {
      type: Function,
      default: null
    },
    projectId: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      list: [],
      options: {},
      parentRadio: '',
      childRadio: ''
    };
  },
  computed: {
    paramOptions() {
      return this.options[this.parentRadio]?.filter(f => !!f.field) || [];
    },
    showChild() {
      return this.paramOptions.length > 0;
    },
    radioVo() {
      return { 
        parent: { value: this.parentRadio, label: this.getParentLabel(this.parentRadio) }, 
        child: { value: this.childRadio, label: this.getChildLabel(this.childRadio) } 
      };
    }
  },
  watch: {
    params: {
      handler(val) {
        if (!val) {
          return;
        }
        this.list = this.transformList(val);
        this.initOptions();
        this.setDefaultValue();
      },
      deep: true
    },
    paramOptions: {
      deep: true,
      handler(val) {
        if (!val || !val.length) {
          return;
        }
        this.childRadio = val[0]?.field;
      }
    },
    parentRadio(val) {
      this.loadOptions(val);
      this.$emit('parent-change', { 
        value: val, 
        label: this.getParentLabel(val) 
      });
    },
    childRadio(val) {
      this.$emit('child-change', { 
        value: val, 
        label: this.getChildLabel(val)
      });
    },
    radioVo(val) {
      this.$emit('change', val);
    }
  },
  methods: {
    async loadOptions(code) {
      if (!this.requestFunc || !code || !CAN_QUERY_CODE.includes(code) || !!this.options[code]?.length) {
        return;
      }
      const list = await this.requestFunc({
        fieldCode: code,
        projectId: this.projectId
      });
      this.$set(this.options, code, list.map(l => ({
        field: l.value,
        fieldName: l.name
      })));
      this.childRadio = this.paramOptions[0]?.field;
    },
    initOptions() {
      this.list.forEach(item => {
        if (item.key) {
          this.$set(this.options, item.key, item.options || []);
        }
      });
    },
    transformList() {
      if (Array.isArray(this.params)) {
        return this.params.map(item => ({
          name: item.fieldName,
          key: item.fieldCode,
          options: item.options || []
        }));
      }
      return Object.keys(this.params).map(key => ({
        name: this.params[key].name,
        key,
        options: this.params[key].options || []
      }));
    },
    setDefaultValue() {
      this.parentRadio = this.list[0]?.key || null;
      this.childRadio = this.paramOptions[0]?.field || null;
    },
    getParentLabel(key) {
      return this.list.find(f => f.key === key)?.name || null;
    },
    getChildLabel(key) {
      return this.paramOptions.find(f => f.field === key)?.fieldName || null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@zk/theme/lib/mixins.scss';

@include b(formula-custom-popover-item) {
 @include e(develop-plane) {
   background: #f5f5f5;
   padding: 6px 16px;
   margin-top: 8px;
   border-radius: var(--radius-mini);
 }
 @include e(radio) {
   @include m(child) {
    margin: 6px 20px 6px 0;
   }
 }
 @include e(radio-warp) {
   display: flex;
   flex-wrap: wrap;
 }
 @include e(radio-item) {
   display: flex;
   align-items: center;
 }
}
</style>
